import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const AccountsOrganizationLayout = () => {
    const navList = useNav();
  let {accountOrgBottomNav, topAccountNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={accountOrgBottomNav} topTabs={topAccountNav} />
      <Outlet />
    </div>
  )
}

export default AccountsOrganizationLayout;